import moment from 'moment';

import { TimeBlock, TimeCard } from '~/data/worktime';

export const findRunningTimeBlock = (
  todaysTimeCard?: TimeCard,
): TimeBlock | undefined => {
  if (todaysTimeCard) {
    const now = moment().format('HH:mm');
    return todaysTimeCard.timeBlocks.find(({ from, to }) => {
      return from && !to && moment(from, 'HH:mm:ss').format('HH:mm') <= now;
    });
  }

  return undefined;
};
